import React, { Component } from "react";

//Import CSS
import "./table.css";

//Import internal components
import TrackingTableLine from "./tracking-table-line";

//Import external components
import Table from "react-bootstrap/Table";

import ReactPaginate from "react-paginate";

import { BsArrowUpShort, BsArrowDownShort } from "react-icons/bs";

//Import images

const TRACKING_SORTABLE_COLUMNS = [
  {
    field: "id",
    type: "number",
    className: "",
    title: (
      <>
        PEDIDO
        <br />
        LABORATÓRIO
      </>
    ),
  },
  {
    field: "idPedidoOtica",
    type: "text",
    className: "hide-table-column hide-table-column-tablet",
    title: (
      <>
        PEDIDO
        <br />
        ÓTICA
      </>
    ),
  },
  {
    field: "dataEntrada",
    type: "date",
    className: "",
    title: (
      <>
        DATA DO
        <br />
        PEDIDO
      </>
    ),
  },
  {
    field: "dataEntregaPrevista",
    type: "date",
    className: "hide-table-column",
    title: (
      <>
        DATA
        <br />
        PREVISTA
      </>
    ),
  },
  {
    field: "statusAtual",
    type: "text",
    className: "hide-table-column",
    title: "STATUS",
  },
];

export class TrackingTableHead extends Component {
  constructor(props) {
    super();

    this.state = {
      data_tabela: props.data_tabela,
      tableAux: props.data_tabela,
      pageCount: Math.ceil(props.data_tabela.length / 10),
      offset: 0,
      selectedPage: 0,
      orderedColumn: "dataEntrada",
      ascOrder: false,
    };

    this.paginateData = this.paginateData.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.orderByColumn = this.orderByColumn.bind(this);
  }

  componentDidMount() {
    this.paginateData();
  }

  paginateData() {
    const dataPagination = this.state.tableAux.slice(this.state.offset, this.state.offset + 10);
    this.setState({ data_tabela: dataPagination });
  }

  handlePageClick = e => {
    const selectedPage = e.selected;
    const offset = selectedPage * 10;

    this.setState({ offset, selectedPage }, this.paginateData);
  };

  compareValues(valorA, valorB, type) {
    if (type === "date") {
      return new Date(valorA) - new Date(valorB);
    }
    if (type === "number") {
      const numeroA = Number(valorA);
      const numeroB = Number(valorB);
      if (!Number.isNaN(numeroA) && !Number.isNaN(numeroB)) {
        return numeroA - numeroB;
      }
    }
    return String(valorA).localeCompare(String(valorB), "pt-BR", { numeric: true, sensitivity: "base" });
  }

  orderByColumn(column) {
    const { orderedColumn, ascOrder, tableAux } = this.state;
    const novaOrdemAsc = orderedColumn === column.field ? !ascOrder : true;
    const direcao = novaOrdemAsc ? 1 : -1;

    const dadosOrdenados = [...tableAux].sort((a, b) => {
      const valorA = a[column.field];
      const valorB = b[column.field];
      const vazioA = valorA === null || valorA === undefined || valorA === "";
      const vazioB = valorB === null || valorB === undefined || valorB === "";
      if (vazioA && vazioB) return 0;
      if (vazioA) return 1;
      if (vazioB) return -1;
      return direcao * this.compareValues(valorA, valorB, column.type);
    });

    this.setState(
      {
        tableAux: dadosOrdenados,
        orderedColumn: column.field,
        ascOrder: novaOrdemAsc,
        offset: 0,
        selectedPage: 0,
      },
      this.paginateData,
    );
  }

  render() {
    const { orderedColumn, ascOrder } = this.state;

    return (
      <div ref={this.integraPedido}>
        {this.props.submitted}

        <div className="pagination-container">
          <ReactPaginate
            previousLabel={"Anterior"}
            nextLabel={"Próximo"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.handlePageClick}
            forcePage={this.state.selectedPage}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </div>

        <Table className="pedidos table text-center">
          <thead className="thead-dark">
            <tr>
              <th className="tracking-pedidos-thead-th"></th>
              <th className="tracking-pedidos-thead-th"></th>
              {TRACKING_SORTABLE_COLUMNS.map(column => (
                <th
                  key={column.field}
                  className={`${column.className} tracking-pedidos-thead-th tracking-th-sortable`.trim()}
                  onClick={() => this.orderByColumn(column)}>
                  <div className="tracking-th-sort">
                    <div>{column.title}</div>
                    <div>{ascOrder && orderedColumn === column.field ? <BsArrowUpShort size={20} /> : <BsArrowDownShort size={20} />}</div>
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          {this.state.data_tabela &&
            this.state.data_tabela.map((item, index) => {
              return (
                <TrackingTableLine
                  laboratorio_nome={this.props.laboratorio_nome}
                  laboratorio_cnpj={this.props.laboratorio_cnpj}
                  detailOrder={this.props.detailOrder}
                  otica_cnpj={this.props.otica_cnpj}
                  item={item}
                  index={index}
                  offset={this.state.offset}
                />
              );
            })}
        </Table>

        <div className="pagination-container">
          <ReactPaginate
            previousLabel={"Anterior"}
            nextLabel={"Próximo"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.state.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            onPageChange={this.handlePageClick}
            forcePage={this.state.selectedPage}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </div>
      </div>
    );
  }
}

export default TrackingTableHead;
